/** Accessibility helpers — contrast, high-contrast palette. */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { parseColor } from './index';
/** Relative luminance (WCAG 2.1). */
function luminance(r, g, b) {
    var _a = __read([r, g, b].map(function (c) {
        var s = c / 255;
        return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    }), 3), rs = _a[0], gs = _a[1], bs = _a[2];
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}
/** Contrast ratio between two CSS colors (1–21). */
export function contrastRatio(fg, bg) {
    var a = parseColor(fg);
    var b = parseColor(bg);
    var l1 = luminance(a.r, a.g, a.b);
    var l2 = luminance(b.r, b.g, b.b);
    var lighter = Math.max(l1, l2);
    var darker = Math.min(l1, l2);
    return (lighter + 0.05) / (darker + 0.05);
}
/** WCAG AA normal text: ratio ≥ 4.5. */
export function meetsWcagAA(fg, bg) {
    return contrastRatio(fg, bg) >= 4.5;
}
var HC_PALETTE = {
    bg: '#000000',
    fg: '#ffffff',
    accent: '#ffff00',
    border: '#ffffff',
    muted: '#cccccc',
};
/** Map a color to high-contrast palette when enabled. */
export function toHighContrastColor(color, kind) {
    if (kind === void 0) { kind = 'fill'; }
    if (!color || color === 'transparent')
        return kind === 'fill' ? HC_PALETTE.bg : HC_PALETTE.border;
    if (kind === 'stroke')
        return HC_PALETTE.border;
    if (kind === 'text')
        return HC_PALETTE.fg;
    return HC_PALETTE.accent;
}
export { HC_PALETTE };
